/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { useRouter } from 'next/router'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import isEmpty from 'lodash-es/isEmpty'

import { useFilterCompaniesTagStyles } from './filter-companies-tag.styles'
import { FilterPlaceTag, removeEmptyFilterOptions } from '../common'
import { FilterSpecialisationsCompanyTag } from '../common/filter-specializations-company'
import { Chip } from '@material-ui/core'
import { TranslationDictionary } from '@plandi/common'

interface IFilterCompaniesTagProps {
  translate?: TranslationDictionary['data']
}

export const FilterCompaniesTag: React.FC<IFilterCompaniesTagProps> = ({
  translate
}) => {
  const classes = useFilterCompaniesTagStyles()
  const router = useRouter()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const newQuery = removeEmptyFilterOptions(router.query)
  const key = 'portfolio'
  const statePortfolio = router.query[key] === '1'

  if (isEmpty(newQuery) || isMobile) {
    return null
  }

  return (
    <div className={classes.groupChip}>
      <FilterPlaceTag typeForSearch={'company'} />
      <FilterSpecialisationsCompanyTag typeForSearch={'company'} />
      {statePortfolio && (
        <Chip
          label={
            translate?.['job-site']?.['availability-portfolio'] ??
            'Наличие портфолио'
          }
          color="primary"
          onDelete={() =>
            router.push(
              {
                pathname: router.pathname,
                query: {
                  ...newQuery,
                  [key]: undefined
                }
              },
              undefined,
              {
                shallow: true
              }
            )
          }
        />
      )}
    </div>
  )
}
